import React from "react";
import { Button, Tooltip, Popconfirm, Space } from "antd";
import {
  EyeOutlined,
  EditOutlined,
  DeleteOutlined,
  CloseCircleOutlined,
  CheckCircleOutlined
} from "@ant-design/icons";

const TeamActions = ({
  currentUser,
  member,
  onView,
  onEdit,
  onDelete,
  onToggleStatus
}) => {
  const role = currentUser?.user?.role;
  const currentUserId = currentUser?.user?._id || currentUser?.user?.id;

  const isSuperAdmin = role === "super_admin";
  const isAdmin = role === "admin";
  const isSelf = currentUserId === member?._id;

  const canEdit = isSuperAdmin;
  const canToggleStatus = isSuperAdmin && !isSelf;
  const canDelete = isSuperAdmin && !isSelf; // ⭐ core rule

  return (
    <Space>
      <Tooltip title="View">
        <Button icon={<EyeOutlined />} onClick={onView} size="small" />
      </Tooltip>

      {canEdit && (
        <Tooltip title="Edit">
          <Button icon={<EditOutlined />} onClick={onEdit} size="small" />
        </Tooltip>
      )}

      {canToggleStatus && (
        <Tooltip title={member.is_active ? "Deactivate" : "Activate"}>
          <Button
            danger={member.is_active}
            icon={
              member.is_active
                ? <CloseCircleOutlined />
                : <CheckCircleOutlined />
            }
            onClick={onToggleStatus}
            size="small"
          />
        </Tooltip>
      )}

      {canDelete && (
        <Popconfirm
          title="Delete team member?"
          onConfirm={onDelete}
        >
          <Button danger icon={<DeleteOutlined />} size="small" />
        </Popconfirm>
      )}
    </Space>
  );
};


export default TeamActions;
